import { useEffect } from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Layout } from "@components/Layout/index";
import { getEditorials, getModalSettings, getGlobalConfig } from "@lib/api/calls";
import { trackEvent } from "@lib/track-event";
import { Grid } from "@components/Editorials";

export default function Index({
  preview,
  title,
  seo,
  initialEditorials,
  heroEditorial,
  config,
  subscribed,
  modal,
}) {
  useEffect(() => {
    trackEvent("view_page", {
      pageTitle: title,
      pageCategory: "Editorials Page",
      pageLocation: window.location.href,
      pagePath: window.location.pathname,
    });
  }, []);

  return (
    <Layout
      config={config}
      title={title}
      seo={seo}
      subscribed={subscribed}
      isPreview={preview}
      pageFound={true}
      modal={modal}
    >
      <Grid initialEditorials={initialEditorials} heroEditorial={heroEditorial} />
    </Layout>
  );
}

export async function getStaticProps({ locale, preview = false }) {
  const heroEditorial = await getEditorials(preview, 0, 1);
  const editorials = await getEditorials(preview, 1, 7);
  const modal = await getModalSettings(locale, preview);
  const config = await getGlobalConfig(locale, preview);

  const seo = {
    seoTitle: `Editorials | Kotn`,
    seoDescription: `Stories on our newest arrivals, how to style them, and a look into the lives of those who wear them.`,
    openGraphImage: heroEditorial[0]?.meta?.openGraphImage || null,
    twitterCard: "summary_large_image",
  };

  return {
    props: {
      preview,
      title: "Our Editorials",
      seo,
      initialEditorials: editorials || [],
      heroEditorial: heroEditorial[0] || null,
      modal,
      config,
      ...(await serverSideTranslations(locale, [
        "common",
        "navbar",
        "footer",
        "cart",
        "productcard",
        "recommendations",
      ])),
    },
    revalidate: 60,
  };
}
